import sublimationPrinting from "./templates/sublimation-printing";
import image1 from "../../assets/images/materials/cup/1.jpg";
import image2 from "../../assets/images/materials/cup/2.jpg";
import image3 from "../../assets/images/materials/cup/3.jpg";
import image4 from "../../assets/images/materials/cup/4.jpg";
import image5 from "../../assets/images/materials/cup/5.jpg";

export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<p>Могли ли вы себе представить, что простая кружка станет полем для творчества, холстом для художника? Нет? Теперь это возможно на Printio! Мы добавили возможность разрисовать ее от края до края. Это уже не просто кружка для любимого напитка - это шедевр творческой мысли, превращающий обычное чаепитие в феерию для всех органов чувств. Наслаждайтесь процессом с нашими новыми кружками с полной запечаткой!</p><p>Керамика - первый материал, созданный человеком искусственно.</p><p>Высота: 9.5 см</p><p>Емкость: 300 мл</p><p>Размер изображения: 97х204 мм</p>`,
      images: [
        {source: image1},
        {source: image2},
        {source: image3},
        {source: image4},
        {source: image5}
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
